import styled from "styled-components";

export const OverviewBody = styled.div`
  &&& {
    padding: 40px 70px 20px 70px;

    &.landscape > div:first-child {
      width:48%;
      float:left;
    }
    &.landscape > div:last-child {
      width:48%;
      float:right;
      margin-top:-1rem;
    }

    @media print {
      padding-top: 20px;
    }

    &.breathing-room {
      padding-top: 45px;

      @media print {
        padding-top: 40px;
      }
    }

    .no-pad-bottom-row {
      padding-bottom: 0 !important;
    }

    .no-pad-top-row {
      padding-top: 0 !important;
    }

    .column-header {
      white-space: normal;
    }

    h3 {
      color: #888;
      font-weight: bold;
      font-size: 24px;
      margin-top: 0;
      text-transform: uppercase;
    }
    h4 {
      padding: 0;
    }
    .column {
      font-family: "Roboto", sans-serif;
      font-weight: bold;
    }
    .row {
      padding: 10px 0;
      font-size: 16px;
      white-space: nowrap;

      &.compact {
        padding: 5px 0;
      }

      h3 {
        font-size: 26px;
      }

      h4 {
        font-size: 20px;
        font-weight: normal;
      }

      &.pad-top {
        padding-top: 30px;

        @media print {
          padding-top: 25px;
        }
      }
    }
  }
`;

export const OverviewFooter = styled.div`
  &&& {
    position: absolute;
    left: 35px;
    bottom: 95px;
    h3 {
      color: ${props => props.theme.grey};
      font-weight: bold;
      font-size: 24px;
      margin-top: 0;
    }
    h4 {
    }
    p {
      padding: 0;
      margin: 0;
      font-size: 14px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/DomainScores/components/OverviewTable/style.js